export default __webpack_public_path__ + "static/media/inicio.e429d533.svg";